import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.1.1?node-id=9955%3A26227
 *
 * @param {SvgIconProps} props - svg props
 */
export const MenuExpandedIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path fillRule='evenodd' clipRule='evenodd' d='M18.2149 14.1588C18.5132 14.4785 18.2866 15 17.8494 15L6.15061 15C5.71342 15 5.48678 14.4785 5.78508 14.1588L11.6345 7.89164C11.8321 7.67985 12.1679 7.67985 12.3655 7.89164L18.2149 14.1588Z' fill={color}/>
        </SvgIcon>
    )
}

export default MenuExpandedIcon
